import { PrimitiveValueObject } from '@/domain/primitiveValueObject';

export class Price extends PrimitiveValueObject<number> {
  /**
   * 生成
   * @param value 値
   * @returns 値
   */
  static create(value: number): Price {
    return new Price(value);
  }
}
